<template>
  <div id="loader" v-show="(isLoading || onRouterChange) && !isSyncing">
    <loading
      :active="true"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="'$primary'"
      :background-color="'#ababab'"
      :loader="'dots'"
    />
  </div>
</template>

<script>
import AxiosStatic from "axios";
import store from "../store";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
//loader queue to store
const loaderCache = new Set();

export default {
  name: "loader",
  components: {
    Loading
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    onRouterChange() {
      return store.getters.onRouterChange;
    },
    isSyncing() {
      return store.getters.isSyncing;
    }
  }
};

// Add a request interceptor
AxiosStatic.interceptors.request.use(
  function (config) {
    // When does not need show loader
    if (config.url.includes("/api/BusinessIndustry/List") ||
        config.url.includes("/api/business/saveCurrentMonthChecklist")) {
      return config;
    }
    //all other requests need to add into queue for tracking
    loaderCache.add(config.url);

    store.commit("setIsLoading", true);
    return config;
  },
  function (error) {
    // Do something with request error
    //reset queue
    loaderCache.clear();
    store.commit("setIsLoading", false);
    store.commit("setOnRouterChange", false);
    return Promise.reject(error);
  }
);

// Add a response interceptor
AxiosStatic.interceptors.response.use(
  function (response) {
    //remove request from queue if receive response
    loaderCache.delete(response.config.url)

    //only drop the loading screen when no more request on queue
    if (loaderCache.size === 0) {
      store.commit("setIsLoading", false);
      store.commit("setOnRouterChange", false);
    }
    return response;
  },
  function (error) {
    //reset queue
    loaderCache.clear();
    store.commit("setIsLoading", false);
    store.commit("setOnRouterChange", false);
    return Promise.reject(error);
  }
);
</script>
